import type { ICellRendererParams } from 'ag-grid-enterprise';

import { isNotDefined } from '@enterprise/core';
import { NumberFormat } from '@enterprise/ui';

/**
 * Renders a formatted number cell for ag-Grid.
 *
 * This renderer checks if the provided value is defined. If not, it returns an empty string.
 * Otherwise, it formats the number using `formatNumber` with zero maximum fraction digits.
 *
 * @template TData - The type of row data.
 * @template TContext - The type of grid context.
 * @param params - The cell renderer parameters, including the value to render.
 * @returns The formatted number as a string, or an empty string if the value is not defined.
 */
function NumberCellRenderer<TData = Record<string, unknown>, TContext = unknown>({
  value,
}: ICellRendererParams<TData, number, TContext>) {
  if (isNotDefined(value)) {
    return null;
  }

  return (
    <NumberFormat
      className="flex grow justify-end"
      decimals={0}
      value={value}
    />
  );
}

export default NumberCellRenderer;
